import { Class } from 'src/interfaces/class.types';

export const getClassesBks = (classes: Class[] | undefined) => {
  if (!classes || !classes.length) return [];

  return classes.map((classObj) => classObj.sourcedId);
};
